import bootbox from 'bootbox';
import {defineMessages, IntlShape} from 'react-intl';

import './ConfirmDialog.scss';

const messages = defineMessages({
    cancel: {id: 'common.cancel', defaultMessage: 'Cancel'}
});

/**
 * Show confirm dialog with unified style and default configuration
 * @param  {object} config Configuration of confirm dialog:
 *               * title {string, optional} [default none] Title of the dialog, should be similar to name of invoked button text
 *               * message {string, required} Main text of the dialog, could contain html elements (like <br />, <strong>, ect.)
 *               * cancel {string, optional} [default Cancel] Text of cancel button
 *               * confirm {string, required} Text of the confirm button. Has to be clear action text (like Disconnect application). NOT: Yes, Do it, etc. + Has to be different from cancel button. Like if some action should be confirm cancable, ask for Interuption. Not should it be cancel? cancel | cancel
 *               * confirmStyle {string, optional} [default btn-primary] class of confirm button. Should reflect type of action (e.g. btn-danger for destuctive actions)
 *               * confirmInput {boolean, optional} [default false] Whether to show an input field for text entry
 *               * inputPlaceholder {string, optional} Placeholder text for the input field
 * @return {Promise}        Resovle on confirm, reject on cancel. If confirmInput is true, resolves with the input value
 */
export default function confirmDialog(intl, config) {
    return new Promise((resolve, reject) => {
        const dialogConfig = {
            className: 'ConfirmDialog confirm-style-' + (config.confirmStyle || "btn-primary"),
            title: config.title,
            message: config.message,
            buttons: {
                cancel: {
                    label: config.cancel || intl.formatMessage(messages.cancel),
                    className: "btn-link btn-storno"
                },
                confirm: {
                    label: config.confirm,
                    className: config.confirmStyle || "btn-primary"
                }
            },
            callback: (result) => {
                if (result) {
                    if (config.confirmInput) {
                        const inputValue = document.querySelector('.ConfirmDialog input')?.value;
                        resolve(inputValue);
                    } else {
                        resolve();
                    }
                }
                else {
                    reject();
                }
            }
        };

        if (config.confirmInput) {
            dialogConfig.inputType = 'text';
            dialogConfig.inputOptions = [
                {
                    text: config.inputPlaceholder || '',
                    value: ''
                }
            ];
        }

        bootbox.confirm(dialogConfig);

        // If we need an input field but bootbox doesn't support it natively, create one
        if (config.confirmInput) {
            const messageElement = document.querySelector('.ConfirmDialog .bootbox-body');
            if (messageElement && !messageElement.querySelector('input')) {
                const inputWrapper = document.createElement('div');
                inputWrapper.style.marginTop = '15px';
                
                const input = document.createElement('input');
                input.type = 'text';
                input.className = 'form-control';
                input.placeholder = config.inputPlaceholder || '';
                input.style.marginBottom = '10px';
                
                inputWrapper.appendChild(input);
                messageElement.appendChild(inputWrapper);
                
                // Focus the input
                input.focus();
            }
        }
    });
}
